export default {
  sb: {
    "take-away": "Cancel",
    "please-input": "Please input",
    "please-select": "Please select",
    "pack-up-screen": "Collapse",
    "more-screening": "More",
    sure: "Sure",
    reset: "Reset",
    query: "Query",
    to: "To",
    "start-date": "Start date",
    "end-date": "End date",
    "start-time": "Start time",
    "end-time": "End time",
    "please-enter-the-content": "Please input content",
    "upload-video": "Upload video",
    "please-upload-video-file": "Please upload a video file",
    "only-support-pm4": "Only supports uploading video files in mp4 format",
    "select-all": "Select all",
    "selected-n-item": "Selected {num} items"
  }
};
